import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { selectWork } from '../../Api/selectors';
import { fetchCompany } from '../actions';
import { REQUEST_COMPANY } from '../constants';
import { selectCompany } from '../selectors';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithCompanyComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.company) {
      this.props.fetch();
    } else {
    }
  }

  render() {
    if (!this.props.company && this.props.loading) return <Loader small />;
    if (!this.props.company) return null;
    return this.props.children;
  }
}

WithCompanyComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.companyId),
    loading: selectWork([`${REQUEST_COMPANY}-${ownProps.companyId}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      if (!ownProps.companyId) return;
      dispatch(fetchCompany(ownProps.companyId));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WithCompany = compose(
  withConnect,
  withRouter,
)(WithCompanyComp);
